<div class="text" trans>Accepted Payment Methods</div>
<div class="card-icons">
    <img [src]="getCardIcon('paypal')">
    <img [src]="getCardIcon(card)" *ngFor="let card of acceptedCards">
</div>